<template>
  <Modal v-model="show" title="图片预览" footer-hide width="600px">
    <Carousel v-model="active" loop v-if="show">
      <CarouselItem v-for="item in files" :key="item">
        <div class="one-img">
          <img :src="item" alt="" />
        </div>
      </CarouselItem>
    </Carousel>

  </Modal>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      files: [],
      active: 0,
    };
  },
  methods: {
    open(files) {
      this.files = files;
      this.show = true;
      this.active = 0
    },
  },
};
</script>

<style lang="less" scoped>
.one-img{
  width: 600px;
  height: 400px;
  position: relative;
  overflow: hidden;
  img{
    position: absolute;
    width: 100%;
    height: auto;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
  }
}
</style>